import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import CategoryTable from './CategoryTable';

const ViewCategory = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Category" title="Category List" mainTitle="Category List" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <CategoryTable />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default ViewCategory